export default __webpack_public_path__ + "static/media/info-card-3.e73b3934.jpg";